module.exports = __webpack_public_path__ + "img/classic_thumbnail-400x300.83358f62.jpg";